import React from 'react';

import { ReactComponent as LiquidFertiliserIcon } from './liquid-fertiliser-icon.svg';

export default function FarmbotLiquidFertiliserIcon() {
  return <LiquidFertiliserIcon width={18} />;
}
